import React, { Suspense } from 'react'
import ReactDOM from 'react-dom'

import App from 'conversations/components/App'
import {
  getAppServices,
  registerDesktopAppServices,
  registerWebAppServices,
} from 'conversations/services'
import { history } from 'conversations/store'
import { isRunningInDesktop } from 'conversations/utils/PlatformUtil'
import { lazyRetry } from 'conversations/utils/rendering/LazyRetryRender'
import { PrivateRoute } from 'conversations/utils/routing/PrivateRoute'
import { enableMapSet } from 'immer'
import { Router } from 'react-router'
import { Redirect, Route, Switch } from 'react-router-dom'
import smoothscroll from 'smoothscroll-polyfill'

import { Skeleton } from '@driftt/conversation-components'
import { ThemeProvider, ToastProvider } from '@driftt/dds'
import LoadStyles from '@driftt/tide-core/dist/styles'

import './css/index.css'

LoadStyles()
enableMapSet()

const WelcomePage = lazyRetry(() =>
  import('./components/WelcomePage').then((module) => ({ default: module.WelcomePage }))
)
const DeepLinkPage = lazyRetry(() =>
  import('./components/DeepLinkPage').then((module) => ({ default: module.DeepLinkPage }))
)

// kick off the polyfill!
smoothscroll.polyfill()

// Gotta import this right away so
// it can hook into the browser before
// everything else runs
isRunningInDesktop && !window.Cypress ? registerDesktopAppServices() : registerWebAppServices()
const onUnauthed = () => getAppServices().auth.logout()

const AppRoot = () => (
  <ThemeProvider>
    <ToastProvider>
      <Router history={history}>
        <Suspense fallback={<Skeleton />}>
          <Switch>
            <Redirect exact from="/" to="/conversations" />
            <Redirect
              from="/inboxes/:inboxId/conversations/:conversationId"
              to="/conversations/:conversationId"
            />
            <Redirect from="/inboxes" to="/conversations" />
            <Route path="/conversations/welcome" component={WelcomePage} />
            <Route path="/conversations/deep-link" component={DeepLinkPage} />
            <PrivateRoute
              route={{ path: '/conversations', component: App }}
              onUnauthed={onUnauthed}
            />
          </Switch>
        </Suspense>
      </Router>
    </ToastProvider>
  </ThemeProvider>
)

ReactDOM.render(<AppRoot />, document.getElementById('root'))
